export default () =>
  (divisions, phaseId = null) =>
    divisions.filter(d => d.phaseId === phaseId || phaseId === null);



// WEBPACK FOOTER //
// ./modules/filters/division-phase.filter.js